import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
  signOutEvent,
  myAccountEvent,
  homeEvent,
  loginEvents,
} from "../functions/cleverTap";
import {
  Menu,
  X,
  Home,
  Headphones,
  HelpCircle,
  Bell,
  Smile,
  Hexagon,
  User,
} from "react-feather";
import { Col, Row, Button } from "reactstrap";
// context
import { AppContext } from "../contexts/AppContext";
import "./nbtmenu.css";
const useStyles = makeStyles({
  list: {
    width: 330,
  },
  fullList: {
    width: "auto",
  },
});

export default function TemporaryDrawer(props) {
  // global state
  const { logo, themeColor } = useContext(AppContext);
  const [customerFirstName, setCostomerFirstName] = useState(" ");
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const nonLoggedInMenu = [
    { label: "होम", icon: <Home width="20px" /> },
    { label: "Start Free Trial", icon: <Smile width="20px" /> },
    { label: "सब्सक्रिप्शन प्लान खरीदिये", icon: <Headphones width="20px" /> },
    { label: "न्यूज़लेटर को सब्सक्राइब करें", icon: <Bell width="20px" /> },
    { label: "नवभारत टाइम्स गोल्ड", icon: <Hexagon width="20px" /> },
    { label: "help@navbharatgold.com", icon: <HelpCircle width="20px" /> },
  ];
  const loggedInMenu = [
    { label: "होम", icon: <Home width="20px" /> },
    { label: "मेरा एकाउंट", icon: <User width="20px" /> },
    { label: "न्यूज़लेटर को सब्सक्राइब करें", icon: <Bell width="20px" /> },
    { label: "नवभारत टाइम्स गोल्ड", icon: <Hexagon width="20px" /> },
    { label: "help@navbharatgold.com", icon: <HelpCircle width="20px" /> },
  ];
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const extractFirstName = () => {
    if (localStorage.getItem("customer_details")) {
      let customerDetails = localStorage.getItem("customer_details");
      if (customerDetails)
        customerDetails = JSON.parse(customerDetails)?.full_name?.split(" ")[0];
      setCostomerFirstName(customerDetails);
    }
  };
  useEffect(() => {
    extractFirstName();
  }, [props]);

  const handleLogin = () => {
    window.open(
      `https://jsso.indiatimes.com/sso/identity/login?channel=${process.env.REACT_APP_CHANNEL_SSO_NAME}&ru=${window?.location?.origin}/navbharattimes/sso.html`,
      "Ratting",
      "width=600,height=600,toolbar=0,status=0,"
    );
  };
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <Row
          className="py-2 mx-1"
          style={{ borderBottom: "2px solid #dbd1d1" }}
        >
          <Col className="text-start pl-2">
            <img
              width="80px"
              src={`/navbharattimes-assets/logo/timesgroup.png`}
              alt="logo"
            />
          </Col>
          <Col className="text-right pr-2 pt-1">
            <X className="cursor-pointer" width="20px" />
          </Col>
        </Row>
        {localStorage.getItem("customer_details") ? (
          <Row
            className="py-2 mx-1"
            style={{ borderBottom: "2px solid #dbd1d1" }}
          >
            <Col className="text-start pl-2">
              <p className="login-welcome-text mb-1">नमस्कार</p>
              <b className="login-inro-text mb-1" style={{ fontSize: "20px" }}>
                {customerFirstName}
              </b>
            </Col>
          </Row>
        ) : (
          <Row
            className="py-2 mx-1"
            style={{ borderBottom: "2px solid #dbd1d1" }}
          >
            <Col className="text-start pl-2">
              <Button
                onClick={() => {
                  loginEvents(
                    "login_initiated",
                    "login_initiated",
                    "login_initiated",
                    "topbar"
                  );
                  handleLogin();
                }}
                className="login-btn-nbt-menu mb-2 mt-1"
                style={{
                  border: `2px solid ${themeColor}`,
                  color: themeColor,
                }}
              >
                लॉग इन
              </Button>
              <p className="login-inro-text mb-1">
                लॉग इन करें और प्राप्त करें 30 दिन का अनलिमिटेड इस्तेमाल
              </p>
            </Col>
          </Row>
        )}
        {localStorage.getItem("customer_details")
          ? loggedInMenu.map((text, index) => (
              <>
                <ListItem
                  button
                  key={text.label}
                  onClick={() => {
                    if (index === 0) {
                      homeEvent(
                        "home_button",
                        "home_button",
                        "home_button",
                        "header"
                      );

                      window.location.assign(
                        `${window.location.origin}/navbharattimes/home`
                      );
                    }
                    if (index === 1) {
                      myAccountEvent(
                        "my_account",
                        "my_account",
                        "my_account",
                        "header"
                      );
                      window.open(
                        `${process.env.REACT_APP_CHANNEL_URL}/${process.env.REACT_APP_CHANNEL_NAME}/myaccount`
                      );
                    }
                    if (index === 2) {
                      window.open(
                        `${process.env.REACT_APP_CHANNEL_URL}/${process.env.REACT_APP_CHANNEL_NAME}/subscription`,
                        "__blank"
                      );
                    }
                    if (index === 3) {
                      window.open(
                        `${process.env.REACT_APP_GOLD_URL}/${process.env.REACT_APP_CHANNEL_NAME}`
                      );
                    }
                    if (index === 4) {
                      window.open("mailto:help@navbharatgold.com");
                    }
                  }}
                >
                  <ListItemIcon>{text?.icon}</ListItemIcon>
                  <ListItemText
                    className="menu-item-nbt"
                    primary={text.label}
                  />
                </ListItem>
                <Divider />
              </>
            ))
          : nonLoggedInMenu.map((text, index) => (
              <>
                <ListItem
                  button
                  key={text.label}
                  onClick={() => {
                    if (index === 0) {
                      homeEvent(
                        "home_button",
                        "home_button",
                        "home_button",
                        "header"
                      );

                      window.location.assign(
                        `${window.location.origin}/navbharattimes/home`
                      );
                    }
                    if (index === 1) {
                      loginEvents(
                        "login_initiated",
                        "login_initiated",
                        "login_initiated",
                        "topbar"
                      );
                      handleLogin();
                    }
                    if (index === 2) {
                      window.open(
                        `${process.env.REACT_APP_CHANNEL_URL}/${process.env.REACT_APP_CHANNEL_NAME}/plans`,
                        "__blank"
                      );
                    }
                    if (index === 3) {
                      window.open(
                        `${process.env.REACT_APP_CHANNEL_URL}/${process.env.REACT_APP_CHANNEL_NAME}/subscription`,
                        "__blank"
                      );
                    }
                    if (index === 4) {
                      window.open(
                        `${process.env.REACT_APP_GOLD_URL}/${process.env.REACT_APP_CHANNEL_NAME}`
                      );
                    }
                    if (index === 5) {
                      window.open("mailto:help@navbharatgold.com");
                    }
                  }}
                >
                  <ListItemIcon>{text?.icon}</ListItemIcon>
                  <ListItemText
                    className="menu-item-nbt"
                    primary={text.label}
                  />
                </ListItem>
                <Divider />
              </>
            ))}
      </List>
    </div>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Menu
            onClick={toggleDrawer(anchor, true)}
            className="feather-29 cursor-pointer"
            color={themeColor}
          />
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
